module.exports = __webpack_public_path__ + "static/media/briefcase.c1bfe193.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/briefcase.svg
// module id = 1542
// module chunks = 0